import useChangeDescription from './useChangeDescription';
import useChangeTags from './useChangeTags';
import useConnectingLink from './useConnectingLink';
import useDeactivation from './useDeactivation';
import useDownlinkBlockUnlock from './useDownlinkBlockUnlock';
import useDownlinkSchedule from './useDownlinkSchedule';
import useImport from './useImport';
import useSuspensionReactivation from './useSuspensionReactivation';
import useTransfers from './useTransfers';
import useUplinkBlockUnlock from './useUplinkBlockUnlock';

const LoraWan = {
  useDeactivation,
  useUplinkBlockUnlock,
  useDownlinkBlockUnlock,
  useChangeDescription,
  useChangeTags,
  useConnectingLink,
  useTransfers,
  useImport,
  useDownlinkSchedule,
  useSuspensionReactivation,
};

export default LoraWan;
